import React, { useEffect } from "react";
import { classNames } from "../../../helpers/classNames";

const Radio = ({
  radioName,
  radioInputClass,
  isChecked,
  isDisabled = false,
  radioLabel,
  radioLableClass,
  value,
  className,
  radiopeerbutton,
  onChange = () => {},
  id,
  ...props
}) => {
  return (
    <label htmlFor={id}>
      <div
        className={classNames(
          "relative overflow-hidden flex items-start",
          className,
        )}
      >
        <input
          type="radio"
          name={radioName}
          className={classNames(
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10",
            isDisabled ? "cursor-not-allowed" : "cursor-pointer",
            radioInputClass,
          )}
          checked={isChecked}
          onChange={onChange}
          value={value}
          id={id}
          disabled={isDisabled}
        />
        <div
          className={classNames(
            "relative w-5 h-5 min-w-[20px] border border-shades-02 rounded-full flex items-center justify-center text-[10px] bg-transparent peer-checked:bg-transparent peer-checked:border-la peer-checked:before:bg-palatte before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-3 before:h-3 before:rounded-full before:-translate-y-[50%] before:right-0 before:mx-auto",
            isDisabled ? "opacity-50" : "",
            radiopeerbutton,
          )}
        ></div>
        {radioLabel && (
          <div
            className={classNames(
              "text-base text-test-disabled w-full ml-3 transition-all duration-200",
              isDisabled ? "text-shades-01/50" : "text-text-disabled",
              radioLableClass,
            )}
          >
            {radioLabel}
          </div>
        )}
      </div>
    </label>
  );
};

export default Radio;
